import React, { Component } from 'react';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ModalOK from './CartonisedModalOk';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Card from 'react-bootstrap/Card';
import { Key } from 'react-bootstrap-icons';
import { findFirstItemMatchesCondition } from '@devexpress/analytics-core/analytics-internal';
import * as MySound from '../MySound';


export class CartonisedConfirmInwards extends Component {
    static displayName = CartonisedConfirmInwards.name;
    constructor(props) {
        super(props);
        this.state = {
            sourceRoute: props.location.state,
            loading: false,
            errorAlert: false,
            errorAlertMsg: '', 
            errorAlertOnSuccess: false,
            errorAlertMsgOnSuccess: '',
            registerEntries: [],
            shipmentType: [],
            shipmentConfirmedAlert: false,
            shipmentConfirmedMsg:''
        };
        this.history = props.history;
    }

    componentDidMount() {

        this.getRegisterEntries();

    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data,
        });
    }

    renderDropdown() {
        return (<select
            className="form-select "
            name="selUsername"
            readOnly={this.state.loading}>
            {this.state.shipmentType.map(row =>
                <option key={row.id} value={row.id}>{row.shipmenttype}</option>
            )}
            onChange={this.myfn()}
        </select>)
    }

    render() {
        let progress = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";
        let msg = '';
        let parent = this;
        return (
            <>
                <h4>Confirm Inwards</h4>
                <Row>
                    <Col className="col-4">Shipment:</Col>
                    <Col className="col-8">{this.state.sourceRoute.selectedShipment.shipment_ref}</Col>
                </Row>
                <hr />
                {progress}
                {this.state.registerEntries.length > 0 &&

                    this.state.registerEntries.map(function (item) {
                        var child = parent;
                        return (
                            <div key={item.inwards_id} >
                                <Row >
                                    <Col className="col-3">Account:</Col>
                                    <Col className="col-3">{item.client_namecode} ({item.inwards_id})</Col>
                                    <Col className="col-3">Cartons:</Col>
                                    <Col className="col-3">{item.scanned_carton_count}</Col>
                                </Row>
                                <Row >
                                    <Col className="col-3">Type:</Col>
                                    <Col className="col-3">
                                        <select
                                            className="form-select "
                                            name="selUsername"
                                            readOnly={child.state.loading}                                           
                                            onChange={(e) => {
                                                item.shipmentTypeId = e.target.value
                                                item.shipmentType = child.state.shipmentType[item.shipmentTypeId - 1].shipmenttype;                                             
                                            }}>
                                            {child.state.shipmentType.map(row =>
                                                <option key={row.id} value={row.id}>{row.shipmenttype}</option>
                                            )}
                                        </select>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col className="col-3">Pallets:</Col>
                                    <Col className="col-3">
                                        <input
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => {
                                                item.pallets = e.target.value;
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row >
                                    <Col className="col-3">Waste:</Col>
                                    <Col className="col-3">
                                        <input
                                            pattern="[0-9]*"
                                            onKeyPress={(event) => {
                                                if (!/^[0-9]*\.?[0-9]*$/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => {
                                                item.waste = e.target.value;                                               
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <hr />
                            </div>

                        );
                    })
                }

                <Row>
                    <Col className="col-4"><Button type="button" className="btn btn-danger col-12 mb-2 mt-1" onClick={() => { this.goto('CartonisedChooseShipment', null); }}>Cancel</Button></Col>
                    <Col className="col-8"><Button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { this.confirmInwards() }}>Yes, Confirm this Shipment</Button></Col>
                </Row>

                <ModalOK title='Error' show={this.state.errorAlert} message={this.state.errorAlertMsg} onClickOk={() => { this.setState({ errorAlert: false, errorAlertMsg: '' }); }}  ></ModalOK>
                <ModalOK title='Confirmation' show={this.state.errorAlertOnSuccess} message={this.state.errorAlertMsgOnSuccess} onClickOk={() => { this.goto('CartonisedChooseShipment', null); }}  ></ModalOK>
                <ModalOK title='Confirmation' show={this.state.shipmentConfirmedAlert} message={this.state.shipmentConfirmedMsg} onClickOk={() => { this.goto('CartonisedChooseShipment', null); }}  ></ModalOK>

            </>
        );
    }



    async getRegisterEntries() {
        this.setState({ loading: true });
        fetch(`api/CartonisedInwards/GetRegisterEntries?shipmentReference=` + this.state.sourceRoute.selectedShipment.shipment_ref)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ registerEntries: result.data.registerEntries, shipmentType: result.data.shipmentTypes, loading: false });
                    }
                    else {
                        //this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }


    async confirmInwards() {
        var sourceRoute = this.state.sourceRoute;
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ShipmentReference: sourceRoute.selectedShipment.shipment_ref,
                UserId: sourceRoute.supervisorId,
                Entries: this.state.registerEntries
            })
        };
        const response = await fetch('api/CartonisedInwards/ConfirmInwards', submitRequest);
        const result = await response.json();
        if (result.success) {
            this.setState({ alertMessage: "", loading: false });
            if (result.data === 0) {
                this.goto('CartonisedChooseShipment', null);
            }
            if (result.data > 0) {
                if (result.errorMessage.length > 0) {
                    this.setState({ errorAlertOnSuccess: true, errorAlertMsgOnSuccess: result.errorMessage, loading: false });
                }
                else {
                    this.setState({ shipmentConfirmedAlert: true, shipmentConfirmedMsg: 'Shipment ' + this.state.sourceRoute.selectedShipment.shipment_ref + ' devanned and confirmed', loading: false });
                }
              
            }

            if (result.data < 0) {
                this.setState({ errorAlert: true, errorAlertMsg: result.errorMessage, loading: false });
                MySound.play(MySound.Sound.stop);
            }
        }
        else {
            this.setState({ errorAlert: true, errorAlertMsg: result.errorMessage, loading: false });
            MySound.play(MySound.Sound.stop);
        }
    }


}

export default CartonisedConfirmInwards;
